<template>
  <div class="container-list">
    <div class="common-page common-head">
      <div class="common-page common-head-title">
        <i class="icon-tr--detailed" style="padding-right: 5px"></i>
        巡查方案管理
      </div>
      <!--            <div class="common-page common-head-end" @click="$router.back()">-->
      <!--                <i class="icon-tr-sign-out"></i>-->
      <!--            </div>-->
    </div>
    <!-- <ul class="tab-wrap" style="border:none" >
      <li
        :class="`tab-btn ${nowIndex == index && 'active'}`"
        @click="changeTab(index,tab)"
        v-for="(tab, index) in tabList"
      >
        {{tab.name }}
      </li>
    </ul> -->
    <div class="common-page common-body">
      <div class="common-page common-tool-bar">
        <!-- <el-button type="primary" size="mini" v-hasPermi="['safe:user:query']" class="btn" @click="open"
          >提报</el-button
        > -->
        <el-button
          type="primary"
          size="mini"
          v-hasPermi="['culturalRelics:wenwuInspectionAppScheme:list']"
          class="btn"
          @click="showDia = true"
        >
          查询
        </el-button>
        <el-button
          type="success"
          size="mini"
          v-hasPermi="['inspection:wenwuInspectionAppScheme:export']"
          class="btn"
          @click="output"
        >
          导出数据
        </el-button>
        <!-- <router-link
          v-hasPermi="['safe:user:add']"
          class="btn ml20"
          :to="{ path: '/safe/safe-adduser', query: { inspection: tabList[nowIndex].id == 0 ? 1 : 2 } }"
          ><i class="icon-tr-newly-added"></i>新增</router-link
        > -->
      </div>
      <div class="common-page common-list">
        <el-table :data="list" class="">
          <!-- <el-table-column prop="user_name" label="序号" align="center"> </el-table-column> -->
          <el-table-column prop="schemeNo" align="center" label="方案编号">
          </el-table-column>
          <el-table-column
            prop="hiddenDangerName"
            align="center"
            label="包含单位"
          >
          </el-table-column>
          <el-table-column prop="createTime" align="center" label="提报时间">
          </el-table-column>
          <el-table-column
            prop="hiddenDangerNum"
            align="center"
            label="隐患数量"
          >
          </el-table-column>
          <!-- <el-table-column prop="phonenumber" align="center" label="巡查数据"> </el-table-column> -->
          <el-table-column prop="state" align="center" label="方案状态">
            <template slot-scope="scope">
              {{ Status[scope.row.state] }}
            </template>
          </el-table-column>
          <el-table-column
            prop="STATUS"
            align="center"
            v-if="false"
            label="状态"
          >
            <template slot-scope="scope">
              {{ $map.menuStatus[scope.row.status] }}
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="160px">
            <template slot-scope="scope">
              <router-link
                v-hasPermi="['culturalRelics:wenwuInspectionAppScheme:query']"
                :to="{
                  path: '/wenwu/safe-programme-detail',
                  query: { id: scope.row.id },
                }"
              >
                <el-button type="warning" size="mini">详情</el-button>
              </router-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size="params.pageSize || 10"
        @current-change="pageChange"
        :total="total"
      >
      </el-pagination>
    </div>

    <el-dialog
      title="查询"
      :visible.sync="showDia"
      :close-on-click-modal="false"
    >
      <fm-generate-form
        :data="searchForm"
        :remote="remoteFuncs"
        :value="editData"
        ref="searchForm"
      >
      </fm-generate-form>
      <!-- <fm-generate-form
        :data="searchForm1"
        :remote="remoteFuncs"
        :value="editData"
        v-if="tabList[nowIndex].id == 1"
        ref="searchForm"
      >
      </fm-generate-form> -->
      <div class="center">
        <el-button type="primary" @click="searchSubmit" size="small"
          >确定</el-button
        >
        <el-button @click="cancle" size="small">重置</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      multipleSelection: [], // tab 选择项
      list: [],
      tabList: this.$store.state.user.userInfo.isWenwu
        ? [{ name: "文物巡查", id: 1 }]
        : [{ name: "消防巡查", id: 0 }],
      Status: {
        1: "待设计",
        2: "待审核",
        3: "待施工",
        4: "待评价",
        5: "已完成",
      },
      nowIndex: 0,
      params: { pageNum: 1, pageSize: 10 },
      total: 0,
      showDia: false,
      searchForm: this.$getForm("inspectionSearch"),
      // searchForm1: this.$getForm("userSearchww"),

      editData: {},
      remoteFuncs: {
        _this: this,
        getArea(resolve) {
          var _this = this._this;
          _this
            .$post("/xuncha/xunchaareadetail", {
              c_company_num: _this.$store.state.user.company.cCompanyNum,
            })
            .then((res) => {
              console.log(res);
              resolve(res.data);
            });
        },
        getWWArea(resolve) {
          var _this = this._this;
          _this
            .$post("/xuncha/xunchaareadetailWenWu", {
              c_company_num: _this.$store.state.user.company.cCompanyNum,
            })
            .then((res) => {
              resolve(res.data);
            });
        },
      },
    };
  },
  created() {
    // this.params.inspectionType = this.tabList[this.nowIndex].id == 0 ? 1 : 2;
    this.getList();
  },
  methods: {
    handleSelectionChange(val) {
      console.log(val);
      // this.multipleSelection = val;
    },
    open() {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        // type: "warning",
        center: true,
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    cancle() {
      // this.showDia=false
      this.resetSearch();
    },
    changeTab(index, it) {
      this.nowIndex = index;
      this.params = {
        pageNum: 1,
        pageSize: 10,
        // user_name: "",
        // nick_name: "",
        // x_company_area: "",
        // inspectionType: this.tabList[this.nowIndex].id == 0 ? 1 : 2,
      };
      this.getList();
    },
    changeStatus(it, del) {
      let status = it.status == 1 ? 0 : 1;
      if (del) status = del;
      this.$post("/user/updateuserstatus", {
        user_id: it.user_id,
        status: status,
      }).then((res) => {
        // this.$message.success("操作成功");
        this.$message({
                message: '操作成功',
                type: 'success',
                duration: 700,
              });
        this.getList();
      });
    },
    getList() {
      // getUserList(this.params).then(res=>{
      //     this.total = res.data.count
      //     this.list = res.data.list
      // }).catch(err=>{
      // })
      this.$get(
        "/culturalRelics/wenwuInspectionAppScheme/list",
        this.params
      ).then((res) => {
        // console.log(res)
        this.total = res.total;
        this.list = res.rows;
      });
    },
    pageChange(val) {
      this.params.pageNum = val;
      // this.params.inspectionType = this.tabList[this.nowIndex].id == 0 ? 1 : 2;
      this.getList();
    },
    output() {
      this.downLoadExcel(
        "/culturalRelics/wenwuInspectionAppScheme/export",
        this.params
      );
    },
    searchSubmit() {
      this.$refs.searchForm
        .getData()
        .then((data) => {
          //log(data)
          this.params = { ...this.params, ...data };
          if (
            !(
              (this.params.startTime && this.params.endTime) ||
              (!this.params.startTime && !this.params.endTime)
            )
          ) {
            this.$message({
              type: "error",
              message: "请完整填写开始结束时间!",
            });
            return;
          }

          if (new Date(this.params.startTime) > new Date(this.params.endTime))
            [this.params.startTime, this.params.endTime] = [
              this.params.endTime,
              this.params.startTime,
            ];
          this.params.pageNum = 1;
          if (this.params.schemeNo)
            this.params.schemeNo = Number(this.params.schemeNo);
          // console.log(data)
          this.getList();
          this.showDia = false;
        })
        .catch((e) => {});
    },
    resetSearch() {
      this.$refs.searchForm.reset();
      this.params = { ...this.params, ...this.$refs.searchForm.models };
      this.getList();
    },
  },
};
</script>

<style scoped></style>
